var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
        'base-select-option',
        { 'base-select-option--selected': _vm.selected && !_vm.unselected }
    ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.emitOptionSelect}},[(_vm.multiselectable)?_c('BaseCheckbox',{ref:"checkboxRef",attrs:{"checked":_vm.selected && !_vm.unselected,"disabled":_vm.disabled},on:{"change":_vm.emitOptionSelect}}):_vm._e(),_vm._v(" "+_vm._s(_vm.optionLabel)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }